import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { ColorCircleUi, DataGridIdentifiers, DatagridPremiumUi, OrderArrowsUI } from '../Interface';
import { filter } from 'lodash';
import resourceOneGroupService from '../../service/resourceOneGroup.service';

const ResourceOneGroupReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    resourceOneGroupService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const handleOrderChange = (id, newOrder) => {
    resourceOneGroupService.orderItem(id, { newOrder }).then(() => {
      setRefetchTable(true);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      headerName: 'Megnevezés',
      type: 'string',
    },
    {
      field: 'color',
      headerName: 'Szín',
      type: 'string',
      sortable: false,
      filterable: false,
      renderCell: (data) => (data.row.color ? <ColorCircleUi color={data.row.color} size={20} /> : ''),
    },
    {
      field: 'active',
      headerName: 'Aktív',
      type: 'boolean',
    },
    {
      field: 'visOrder',
      headerName: 'Sorrend',
      type: 'action',
      renderCell: (params) => {
        const disabled = params?.api?.getSortModel()[0]?.field !== 'visOrder';
        const isSortedDescending = params.api.getSortModel()[0]?.sort === 'desc';

        const handleUpClick = () => {
          if (isSortedDescending) {
            handleOrderChange(params.row.id, 'down');
          } else {
            handleOrderChange(params.row.id, 'up');
          }
        };

        const handleDownClick = () => {
          if (isSortedDescending) {
            handleOrderChange(params.row.id, 'up');
          } else {
            handleOrderChange(params.row.id, 'down');
          }
        };

        return <OrderArrowsUI onUpClick={handleUpClick} onDownClick={handleDownClick} disabled={disabled} />;
      },
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.ResourceOneGroupTable}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default ResourceOneGroupReports;
